import React from 'react';

const BlurryButton = ({ onClick, children, ...props }) => (
  <button type="button" tabIndex="-1" {...props} onClick={(e) => (onClick && onClick()) & e.target.blur()}>
    {children}
  </button>
);

export default BlurryButton;
